import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  timeout: 30000,
});

export const getCategories = (lang) =>
  api.get("/categories", { params: lang ? { lang } : {} }).then((r) => r.data);
export const getCategory = (id, lang) =>
  api.get(`/categories/${id}`, { params: lang ? { lang } : {} }).then((r) => r.data);
export const getIllness = (id, lang) =>
  api.get(`/illnesses/${id}`, { params: lang ? { lang } : {} }).then((r) => r.data);
export const listIllnesses = (params = {}) => api.get("/illnesses", { params }).then((r) => r.data);
export const getHijamaPoints = (region, lang) =>
  api.get("/hijama/points", { params: { ...(region ? { region } : {}), ...(lang ? { lang } : {}) } }).then((r) => r.data);
export const getHijamaPoint = (id, lang) =>
  api.get(`/hijama/points/${id}`, { params: lang ? { lang } : {} }).then((r) => r.data);
export const aiSearch = (query) => api.post("/search/ai", { query }).then((r) => r.data);
export const getStats = () => api.get("/stats").then((r) => r.data);
export const getClinic = () => api.get("/clinic").then((r) => r.data);

export const createCheckout = (payload) =>
  api.post("/checkout/create", payload).then((r) => r.data);
export const getCheckoutStatus = (sessionId) =>
  api.get(`/checkout/status/${sessionId}`).then((r) => r.data);
export const downloadPdfUrl = (token, productType = "illness_pdf") => {
  if (productType === "diploma_course") return `${API}/download/diploma-pdf/${token}`;
  if (productType === "hijama_atlas_book") return `${API}/download/hijama-atlas-book/${token}`;
  return `${API}/download/illness-pdf/${token}`;
};
export const previewPdfUrl = (illnessId) => `${API}/preview/illness-pdf/${illnessId}`;

// ============ Admin API ============
const ADMIN_TOKEN_KEY = "icc_admin_token";
export const getAdminToken = () => localStorage.getItem(ADMIN_TOKEN_KEY) || "";
export const setAdminToken = (t) => localStorage.setItem(ADMIN_TOKEN_KEY, t);
export const clearAdminToken = () => localStorage.removeItem(ADMIN_TOKEN_KEY);

const adminHeaders = () => ({ Authorization: `Bearer ${getAdminToken()}` });

export const adminLogin = (password) =>
  api.post("/admin/login", { password }).then((r) => r.data);
export const adminDashboard = () =>
  api.get("/admin/dashboard", { headers: adminHeaders() }).then((r) => r.data);
export const adminMarkCertificateSent = (session_id) =>
  api.post("/admin/certificate/mark-sent", { session_id }, { headers: adminHeaders() }).then((r) => r.data);
export const adminRefundOrder = (session_id, reason = "") =>
  api.post(`/admin/orders/${session_id}/refund`, { reason }, { headers: adminHeaders() }).then((r) => r.data);
export const adminMarkDelivered = (session_id) =>
  api.post(`/admin/orders/${session_id}/mark-delivered`, {}, { headers: adminHeaders() }).then((r) => r.data);
export const adminSessionStats = () =>
  api.get(`/tutoring/admin/session-stats`, { headers: adminHeaders() }).then((r) => r.data);
export const adminListSessions = () =>
  api.get(`/tutoring/admin/sessions`, { headers: adminHeaders() }).then((r) => r.data);
export const adminSetSessionStatus = (session_id, status) =>
  api.post(`/tutoring/admin/sessions/${session_id}/status`, { status }, { headers: adminHeaders() }).then((r) => r.data);
export const adminCancelSession = (session_id, reason = "", occurrence_index = null) =>
  api.post(`/tutoring/admin/sessions/${session_id}/cancel`, { reason, occurrence_index }, { headers: adminHeaders() }).then((r) => r.data);
export const adminRescheduleSession = (session_id, new_starts_at, reason = "", occurrence_index = 0) =>
  api.post(`/tutoring/admin/sessions/${session_id}/reschedule`, { new_starts_at, reason, occurrence_index }, { headers: adminHeaders() }).then((r) => r.data);
export const adminNotificationLogs = () =>
  api.get(`/tutoring/admin/notification-logs`, { headers: adminHeaders() }).then((r) => r.data);
export const adminAnalytics = () =>
  api.get("/admin/analytics", { headers: adminHeaders() }).then((r) => r.data);
export const adminCertificatePreviewUrl = (session_id) =>
  `${API}/admin/certificate/${session_id}/preview`;

// Exam bookings (admin)
export const adminExamBookings = () =>
  api.get("/admin/exam-bookings", { headers: adminHeaders() }).then((r) => r.data);
export const adminExamSchedule = (session_id, scheduled_at, notes = "") =>
  api.post("/admin/exam-booking/schedule", { session_id, scheduled_at, notes }, { headers: adminHeaders() }).then((r) => r.data);
export const adminExamResult = (session_id, result, notes = "") =>
  api.post("/admin/exam-booking/result", { session_id, result, notes }, { headers: adminHeaders() }).then((r) => r.data);

// Public exam-pass token validation (used by /certificate-purchase/:token page)
export const lookupExamPass = (token) =>
  api.get(`/exam-pass/${token}`).then((r) => r.data);

// Shop products
export const listShopProducts = (includeInactive = false) =>
  api.get(`/shop/products${includeInactive ? "?include_inactive=1" : ""}`).then((r) => r.data);
export const getShopProduct = (id) => api.get(`/shop/products/${id}`).then((r) => r.data);
export const adminShopCreate = (data) =>
  api.post("/admin/shop/products", data, { headers: adminHeaders() }).then((r) => r.data);
export const adminShopUpdate = (id, data) =>
  api.patch(`/admin/shop/products/${id}`, data, { headers: adminHeaders() }).then((r) => r.data);
export const adminShopDelete = (id) =>
  api.delete(`/admin/shop/products/${id}`, { headers: adminHeaders() }).then((r) => r.data);
export const adminShopUploadImage = (id, file) => {
  const fd = new FormData();
  fd.append("file", file);
  return api.post(`/admin/shop/products/${id}/image`, fd, {
    headers: { ...adminHeaders(), "Content-Type": "multipart/form-data" },
  }).then((r) => r.data);
};
export const shopImageUrl = (id) => `${API}/shop/image/${id}`;
